/* eslint-disable */ // VueEntityManager.vue
<template>
  <div class="entity-manager" v-cloak>
    <div class="entity-list-header" v-if="enableHeader">
      <h3>{{ entityManager.labels.namePlural }}</h3>
    </div>
    <div class="entity-list">
      <div
        class="entity"
        v-for="entity in entityManager.storage"
        :entity="entity"
        :key="entity.nid"
      ></div>
    </div>
  </div>
</template>

<script>
import ErrorHandler from "./../mixins/ErrorHandler.vue";
import EntityCrud from "./../mixins/EntityCrud.vue";
export default {
  props: {
    "entity-manager": {
      type: Object,
      default() {
        return {
          show: false,
          storage: {},
          count: null,
          labels: {
            name: "Entity",
            namePlural: "Entities",
          },
        };
      },
    },
    "load-method": {
      type: String,
      default() {
        return "append";
      },
    },
    "enable-autoload": {
      type: Boolean,
      default() {
        return true;
      },
    },
    "enable-header": {
      type: Boolean,
      default() {
        return true;
      },
    },
    "enable-pagination": {
      type: Boolean,
      default() {
        return true;
      },
    },
    "endpoint-list": {
      type: String,
    },
  },
  data() {
    return {
      params: {},
    };
  },
  mixins: [ErrorHandler, EntityCrud],
  computed: {
    requestParams() {
      return Object.assign(this.params, {
        _format: "json",
      });
    },
  },
  methods: {
    // Load entities and populate storage container.
    loadEntities(params, endpoint, resetStorage) {
      let _this = this;
      let requestParams = Object.assign(params, this.requestParams);
      if (!this.endpointList && !endpoint) {
        return Promise.reject("No list endpoint specified.");
      }

      if (this.endpointList) {
        endpoint = this.endpointList;
      }

      return this.listEntities(endpoint, requestParams, resetStorage)
        .then((response) => {
          if (response.data.results == undefined) {
            response.data.results = [];
          }
          //this.$set(this.personObject, "bio", bio); // this was needed on vue 2
          //this.personObject["bio"] = bio;

          _this.entityManager["count"] = parseInt(response.data.count);
          /*_this.$set(
            _this.entityManager,
            "count",
            parseInt(response.data.count)
          );*/
          if (_this.loadMethod === "replace" || resetStorage) {
            // _this.$set(_this.entityManager, "storage", response.data.results);
            _this.entityManager["storage"] = response.data.results;
          } else {
            if (!_this.entityManager.storage.length) {
              _this.entityManager.storage = [];
            }
            _this.entityManager.storage = _this.entityManager.storage.concat(
              response.data.results
            );
          }

          // Set facets data.
          if (response.data.facets != undefined) {
            _this.entityManager["facets"] = response.data.facets;
            //_this.$set(_this.entityManager, "facets", response.data.facets);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    if (this.enableAutoload === true) {
      // this.loadEntities({page: 0}).catch((e) => {
      //   console.log(e);
      // });
    }
  },
};
</script>
